React = require 'react'
l = require 'app/scripts/lib/localize'
{ track } = require '@trello/analytics'
{ debounce } = require 'underscore'
{ unsplashApi, toJson, trackUnsplashViewsById } = require 'app/scripts/network/unsplash'

PhotosList = require './photos-list'

DEBOUNCE_DELAY = 250
DEFAULT_COLLECTION_ID = 317099
PAGE_SIZE = do ->
  maxItemsInScreen = Math.ceil((screen.height / 112) * 2)
  maxItemsWithBuffer = Math.ceil(maxItemsInScreen * 1.5)

  # We want an even number
  if maxItemsWithBuffer % 2
    maxItemsWithBuffer++

  maxItemsWithBuffer

module.exports = class extends React.Component
  displayName: 'PhotosView'

  constructor: (props) ->
    super(props)

    createCollection = (id) ->
      {
        connectionError: false
        id
        images: []
        isLoading: false
        marker: null
        maxPage: 1
        page: 1
      }

    @state = {
      collections: [
        createCollection(DEFAULT_COLLECTION_ID)
        createCollection('search')
      ]
      defaultCollectionActive: true
      defaultCollectionShowTitle: false
      queueID: 0
      searchTerm: null
    }

  componentWillMount: ->
    @debouncedGetUnsplashBackgrounds = debounce(@getUnsplashBackgrounds, DEBOUNCE_DELAY)

  componentDidMount: ->
    # Start requesting the default collection
    @getUnsplashBackgrounds(DEFAULT_COLLECTION_ID)

  render: ->
    {
      boardId
      collections
      defaultCollectionActive
      defaultCollectionShowTitle
      searchTerm
    } = @state

    React.createElement('div', { className: 'board-backgrounds-photos' },
      React.createElement('div', { className: 'search-photos' },
        React.createElement('input', {
          onChange: @onSearchInputChange
          placeholder: l(['background photos', 'photos'])
          type: 'text'
        }),
        React.createElement('span', { className: 'icon-sm icon-search' })
      )
      if @props.cancelable
        React.createElement('a', {
          className: 'button subtle cancel-button',
          href: '#',
          onClick: => @props.onCancel()
        }, l(['background photos', 'cancel keep background']))
      React.createElement('div', {
        className: 'board-backgrounds-list-observer'
        ref: @bindObserver
      },
        if searchTerm then @renderList('search'),
        if defaultCollectionShowTitle then React.createElement('div', { className: 'collection-title' }, l(['background photos', 'top picks'])),
        if defaultCollectionActive then @renderList(DEFAULT_COLLECTION_ID)
      )

    )

  ###################################################
  # Helper functions ################################
  ###################################################

  renderList: (collectionID) =>
    { boardId } = @props
    { collections } = @state
    {
      connectionError
      images
      isLoading
      maxPage
      page
    } = collections.filter((collection) -> collection.id == collectionID)[0]

    React.createElement(
      PhotosList,
      {
        boardId
        collectionID
        connectionError
        images
        isLoading
        maxPage
        page
        registerMarker: @registerMarker(collectionID)
      }
    )

  onSearchInputChange: (e) =>
    { collections } = @state
    value = e.target.value.trim()

    @setState(
      collections: collections.map((collection) ->
        if collection.id == 'search'
          collection.images = []
          collection.isLoading = true

        collection
      )
      defaultCollectionActive: !value
      defaultCollectionShowTitle: false
      searchTerm: value
    )

    if value
      @debouncedGetUnsplashBackgrounds('search')

  nextPage: (collectionID) =>
    { collections } = @state

    page = collections.filter((collection) -> collection.id == collectionID)[0].page

    @getUnsplashBackgrounds(collectionID, page + 1)

  updateCollection: (id, images, maxPage) =>
    newPhotos = images.map((image) -> image.id)
    trackUnsplashViewsById(newPhotos)

    collections = @state.collections.map (collection) ->
      if collection.id == id
        collection.connectionError = false
        collection.images = collection.images.concat(images)
        collection.isLoading = false
        collection.maxPage = maxPage

      collection

    defaultCollectionActive = true
    defaultCollectionShowTitle = false

    if id == 'search'
      defaultCollectionActive = !collections.filter((collection) -> collection.id == 'search')[0].images.length
      defaultCollectionShowTitle = defaultCollectionActive

    @setState({
      collections
      defaultCollectionActive
      defaultCollectionShowTitle
    })

  showErrorInCollection: (collectionID) =>
    @setState({
      collections: @state.collections.map((collection) ->
        if collection.id == collectionID
          collection.connectionError = true
          collection.isLoading = false
        collection
      )
    })

  getUnsplashBackgrounds: (collectionID, page = 1) =>
    { collections, queueID, searchTerm } = @state

    queueID++

    @setState({
      queueID
      collections: collections.map((collection) ->
        if collection.id == collectionID
          collection.page = page
          collection.isLoading = true
        collection
      )
    })

    (
      if collectionID == 'search'
        unsplashApi
          .search
          .photos searchTerm, page, PAGE_SIZE
          .then toJson
          .then ({ results, total }) =>
            # Forget about outdated search requests
            if @state.queueID == queueID
              @updateCollection(collectionID, results, Math.ceil(total / PAGE_SIZE))
      else
        unsplashApi
          .collections
          .getCollectionPhotos collectionID, page, PAGE_SIZE, 'latest'
          .then toJson
          .then (images) =>
            # We don't have collection size, so we just make maxPage higher by 1
            maxPage = page + 1

            if images.length < PAGE_SIZE
              maxPage = page

            @updateCollection(collectionID, images, maxPage)
      ).catch(=>
        @showErrorInCollection(collectionID)
      )


  registerMarker: (collectionID) -> (marker) =>
    # React ref will sometimes fire with the first param undefined
    if not marker then return

    collections = @state.collections.map((collection) ->
      if collection.id == collectionID
        collection.marker = marker

      collection
    )

    @setState({ collections })

    if @observer
      @bindMarkers()

  bindObserver: (observerRoot) =>
    # React ref will sometimes fire with the first param undefined
    if @observer or not observerRoot then return

    { collections } = @state

    callback = (entries) =>
      for entry in entries
        # We only need isIntersecting, polyfill works but Chrome <= 56 doesn't have it
        intersected = entry.isIntersecting || entry.intersectionRatio
        collection = collections.filter((collection) -> collection.marker == entry.target)[0]

        if (intersected and not collection.isLoading)
          @nextPage(collection.id)

    @observer = new IntersectionObserver(callback, { root: observerRoot })

    @bindMarkers()

  bindMarkers: =>
    { collections } = @state

    @observer.disconnect()

    for collection in collections
      if collection.marker
        @observer.observe(collection.marker)
